import * as styles from './Divider.module.css'

function Divider() {
  return <div className={styles.divider} />
}

export default Divider
